export enum OptionModeEnum {
    save = 'save',
    deselect = 'deselect',
    select = 'select'
}
